import { createContext } from 'react';
import { QUERY_KEYS_CIHA, useChartsData } from '../../Common/hooks/useChartsData';
import { useCIHAFiltersContext } from '../../Common/Filters/hooks/useCIHAFiltersContext';

export const PacientProfileChartsDataContext = createContext();

const PacientProfileChartsDataProvider = ({ children }) => {
    const { filters } = useCIHAFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
        cnes: filters.unidade?.value,
        ano: filters.year?.value || currentYear,
        mes: filters.month?.value
    };

    const bySex = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PATIENT_BY_SEX,
            url: 'governanceroom/cihadashboard/patientBySex'
        },
        filterParams
    );

    const agePyramid = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PATIENT_AGE_PYRAMID,
            url: 'governanceroom/cihadashboard/patientAgePyramid'
        },
        filterParams
    );

    const sexByYear = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PATIENT_SEX_BY_YEAR,
            url: 'governanceroom/cihadashboard/patientSexByYear'
        },
        filterParams,
        true
    );

    const avgPermanenceByAge = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PATIENT_AVG_PERMANENCE_BY_AGE,
            url: 'governanceroom/cihadashboard/patientAvgPermanenceByAge'
        },
        filterParams
    );

    const queries = [bySex, agePyramid, sexByYear, avgPermanenceByAge];
    const isLoading = queries.some((query) => query.isLoading);
    const isError = queries.some((query) => query.isError);

    const chartData = {
        bySex: bySex.data?.por_sexo || [],
        bySexTotal: bySex.data?.total_registros || 0,
        agePyramid: agePyramid.data?.piramide_etaria || {},
        sexByYear: sexByYear.data?.sexo_por_ano || {},
        avgPermanenceByAge: avgPermanenceByAge.data?.permanencia_por_faixa_etaria || {}
    };

    return (
        <PacientProfileChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters
            }}
        >
            {children}
        </PacientProfileChartsDataContext.Provider>
    );
};

export default PacientProfileChartsDataProvider;
